import * as Menu from '../../../components/menu/constants'
import * as GridCell from '../../grid-cell'
import * as Constants from '../constants'
import * as Types from '../types'

export class ActiveCell extends GridCell.ActiveAndEditCell<Types.Source> {
  constructor(props: any) {
    super(props, Constants.UPDATE_SOURCE_INLINE, false, Menu.CONTENT_SOURCE_URL, null)
  }
}



// WEBPACK FOOTER //
// ./src/pages/sources/render/active_cell.tsx